
<div class="kl-message">
    <vl-title :tag-name="titleTag" tag-style="h6" class="kl-message__title" v-html="title"></vl-title>
    <p class="kl-message__content" v-if="content" v-html="content"></p>
</div>